import { motion } from "framer-motion";
import { Phone, MessageCircle, Instagram, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Configurabili dall'admin — per ora statici
const PHONE = "+39 353 452 0559";
const PHONE_TEL = "+393534520559";
const WHATSAPP = "https://wa.me/393534520559";
const INSTAGRAM_URL = "https://instagram.com/davideperugini.cars";
const INSTAGRAM_HANDLE = "@davideperugini.cars";

export default function ContactSection() {
  const { lang } = useLang();
  const items = [
    { icon: Phone, label: lang === "en" ? "Mobile" : "Cellulare", value: PHONE, href: `tel:${PHONE_TEL}`, id: "contact-phone" },
    { icon: MessageCircle, label: "WhatsApp", value: lang === "en" ? "Message me now" : "Scrivimi ora", href: WHATSAPP, id: "contact-whatsapp" },
    { icon: Instagram, label: "Instagram", value: INSTAGRAM_HANDLE, href: INSTAGRAM_URL, id: "contact-instagram" },
  ];
  return (
    <section
      id="contatti"
      className="relative py-32 sm:py-48 px-6 sm:px-10 lg:px-14 max-w-[1600px] mx-auto"
      data-testid="contact-section"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9 }}
        className="flex items-center gap-4 mb-14"
      >
        <span className="w-10 h-px bg-white/40" />
        <span className="label-eyebrow text-white/70">{lang === "en" ? "Contact" : "Contatti"}</span>
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1 }}
        className="font-serif text-5xl sm:text-7xl lg:text-[8vw] font-light leading-[0.9] tracking-tighter text-white"
      >
        {lang === "en" ? "Let's talk." : "Parliamone."}<br />
        <span className="italic text-neutral-500">{lang === "en" ? "Directly." : "Direttamente."}</span>
      </motion.h2>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {items.map(({ icon: Icon, label, value, href, id }, i) => (
          <motion.a
            key={id}
            href={href}
            target={href.startsWith("http") ? "_blank" : undefined}
            rel="noopener noreferrer"
            data-testid={id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className="group relative bg-[#0a0a0a] p-10 md:p-14 flex flex-col justify-between min-h-[240px] hover:bg-[#111] transition-colors duration-500"
          >
            <div className="flex items-center justify-between">
              <Icon size={22} className="text-neutral-500 group-hover:text-white transition-colors duration-500" />
              <ArrowUpRight size={18} className="text-neutral-600 group-hover:text-white group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500" />
            </div>
            <div>
              <div className="label-eyebrow text-neutral-500 mb-3">{label}</div>
              <div className="font-sans font-extralight text-xl md:text-2xl text-white leading-tight tracking-tight whitespace-nowrap">{value}</div>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
